import React, {useState} from 'react';
import {Col, Flex, Row} from "antd";
import {GuaranteePopUPCardProps} from "../../../models";
import {StyledCard} from "./GuaranteePopUp.styled";
import style from "./GuaranteePopUp.module.scss";
import {IoInformationCircleSharp, IoShieldCheckmark} from "react-icons/io5";
import {FaAngleDown, FaAngleUp} from "react-icons/fa";

const GuaranteePopUPCard = ({title,description }: GuaranteePopUPCardProps) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false)

    return (
        <Flex justify={"space-around"} align={"baseline"}>
            <Col xs={8} sm={8} md={8} lg={8} xl={8}>

                <Flex gap={"small"}>
                    <span className={style.greyFont}>{title} </span>
                </Flex>
            </Col>
            <Col xs={15} sm={15} md={15} lg={15} xl={15}>

                <Flex gap={"small"} style={{textAlign:"justify" ,fontSize:"13px"}}>
                    <span>{description} </span>
                </Flex>
            </Col>
        </Flex>
    );
};

export default GuaranteePopUPCard;
